// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3007":"ProjectClientPage","3923":"ProjectDetailPage","8886":"ProjectEditPage"}[chunkId] + "." + {"3007":"dafdae52","3923":"fb3fd99e","8886":"fb3fd99e"}[chunkId] + ".chunk.css";
};